const getFormData = $form => {
    const data = {};
    $.map($form.serializeArray(), o => {
        data[o.name] = data[o.name] ? (data[o.name] + ',' + o.value) : o.value;
    });
    return data;
};

const getUrlData = fromHash => {
    const data = {};
    let search = fromHash ? location.hash.replace('#', '') : location.search.replace('?', '');
    search.indexOf('&') > -1 && (search = search.split('&'));
    !Array.isArray(search) && (search = [search]);
    if ( search.length === 1 && search[0] === '' ) {
        return data;
    }
    $.map(search, param => data[decodeURIComponent(param.split('=')[0])] = decodeURIComponent(param.split('=')[1]));
    return data;
};

const cleanDate = (date) => {
    date = new Date(date);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

const setFormData = (form, data, trigerChange = true) => {

    $.map(data, (val, name) => {

        const elem = form[name];
        
        if ( !elem ) {
            return;
        }
        const $elem = $(elem);

        if($elem.attr('name') == 'dateFrom') {
            elem._flatpickr.setDate(val);
        }
        if($elem.attr('name') == 'dates') {
            let dates = val ? val.split(' - ') : [];

            const date = $elem.closest('.datepicker,.datepicker-range')[0]

            date._flatpickr.clear();
            if(dates[0] && dates[1]) {
                date._flatpickr.setDate([dates[0],dates[1]]);
            } else if(dates[0]) {
                date._flatpickr.setDate([dates[0],dates[0]]);
            }
        }

        if ( elem.type === 'checkbox' ) {
            elem.checked = elem.value == val ? true : false;
        }
        else if ( elem[0] && elem[0].type === 'checkbox' ) {
            val = $.isArray(val) ? val : (val || '').split(',');
            elem.forEach(elem => {
                elem.checked = val.indexOf(elem.value) > -1;
            });
        }
        else if ( elem[0] && elem[0].type === 'radio' ) {
            elem.forEach(elem => {
                elem.checked = elem.value == val;
            });
        }
        else {
            $elem.val(val);
        }
        trigerChange && $elem.trigger('change');
    });
};

const _replaceState = history.replaceState;
history.replaceState = function () {
    const retVal = _replaceState.apply(history, arguments);
    const e = new Event('hashchange');
    e.arguments = arguments;
    window.dispatchEvent(e);
    return retVal;
};
let setUrlTimeout = 0;
const setUrlData = (data, toHash, replace, defaults = false) => {
    clearTimeout(setUrlTimeout);
    setUrlTimeout = setTimeout(() => {
        $.map(data, (value, key) => (!value || (defaults && defaults[key] == value)) && (delete data[key]));
        if ( toHash ) {
            let newHash = $.param(data);
            let oldHash = location.hash.replace('#', '');
            if ( newHash !== oldHash ) {
                if ( replace ) {
                    history.replaceState('', '', '#' + newHash);
                } else {
                    location.hash = newHash;
                }
            }
        } else {
            location.search = $.param(data);
        }
    }, 100);
};

const getDataForUrl = (data) => {
    $.map(data, (value, key) => !value && (delete data[key]));
    if (data.dates) {
        let dates = data.dates.split(' - ');
        data.dateFrom = dates[0];
        data.dateTo = dates[1];
        delete data.dates;
    }

    return data;

};

const getLang = () => {
    return (document.documentElement.lang || '').split('-')[0] || 'hr';
};

const $animateSelector = $('html, body');
const scrollToElement = ($elem, offset) => {
    $elem = $($elem);
    $elem.length && $animateSelector.animate({
        scrollTop: $elem.offset().top - (offset || 0)
    });
};

const smallWin = () => {
    return window.innerWidth < 992;
}

const formatMoney = (n, c, d, t) => {
    var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? "." : d,
        t = t == undefined ? "," : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

const formatDate = (date) => {
    date = new Date(date);
    return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() + '.';
};

const formatDateYmd = (date) => {
    date = date instanceof Date ? date : new Date(date);
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
};

const formatTravelPeriod = (dateFrom, dateTo) => {
    dateFrom = new Date(dateFrom);
    dateTo = new Date(dateTo);

    let dateFromStr = ('0' + dateFrom.getDate()).slice(-2) + '.' + ('0' + (dateFrom.getMonth() + 1)).slice(-2);
    let dateToStr = ('0' + dateTo.getDate()).slice(-2) + '.' + ('0' + (dateTo.getMonth() + 1)).slice(-2) + '.' + dateTo.getFullYear().toString().substr(-2);
    return dateFromStr + '-' + dateToStr;
};

const setCookie = (key, value, expires = null) => {
    let mili = expires ? expires * 24 * 60 * 60 * 1000 : 365 * 24 * 60 * 60 * 1000;
    expires = new Date();
    expires.setTime(expires.getTime() + mili);
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + '; path=/';
};

const getCookie = (key) => {
    let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
};

const isObject = obj => {
    return obj === Object(obj);
};

const isMobile = () => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

const parseIfBool = value => {
    if ( typeof value == 'string' ) {
        value = value === 'true' ? true : value === 'false' ? false : value;
    }
    return value;
};

const markFavorites = () => {
    let cFavs = getCookie('user_favourites');
    cFavs = cFavs ? JSON.parse(cFavs) : {};

    for (const [key, value] of Object.entries(cFavs)) {
        let dp = key.split('_')[2];
        if (value.length)
        {
            value.forEach(unitid => {
                $('.add-favourites[data-unitid="' + unitid + '"][data-dynamicpackage="' + dp + '"]').addClass('active');
            });
        }
    }

    if (cFavs.length)
    {
        cFavs.forEach(unitId => {
            let $elem = $('[data-favunitid="' + unitId+'"]');
            if($elem.length) $elem.addClass('active');
        });
    }
    return;
}

const favoritesLabel = (favs) => {
    let $favLabel = $('.favorites-label');
    if (! $favLabel.length) return;

    let cFavs = favs || getCookie('user_favourites');
    cFavs = cFavs ? JSON.parse(cFavs) : {};
    let total = 0;
    for (const [key, value] of Object.entries(cFavs)) total += value.length;

    $favLabel.find('.total').html(total);
    $favLabel.removeClass('d-none');
    if (total == 0) $favLabel.addClass('d-none');
}

const swipeTreshold = 40; // min difference to consider action as swiping
let swipeTimeout = 0;
let swipeStartX = 0;
let swipeMoveX = 0;

const getSwipeDirection = e => {
	if ( e.type == 'touchstart' || e.type == 'mousedown' ) {
		swipeStartX = e.touches ? e.touches[0].clientX : e.clientX;
		return 0;
	}
	if ( e.type == 'touchmove' || e.type == 'mousemove' ) {
		swipeMoveX = e.touches ? e.touches[0].clientX : e.clientX;
		return 0;
	}
	if ( e.type == 'touchend' || e.type == 'mouseup' ) {
		let swipeDiff = swipeMoveX > 0 ? Math.abs(swipeStartX - swipeMoveX) : 0;
		return swipeDiff > swipeTreshold ? (swipeMoveX > swipeStartX ? -1 : 1) : 0;
	}
};

const dateDiff = (dateFrom, dateTo) => {

}


const cleanParams = params => {

    Object.keys(params).forEach((key) => {
        (params[key] == null || params[key] == '') && delete params[key];
    });

    return params;
};

module.exports = {
    cleanDate: cleanDate,
    getFormData: getFormData,
    getUrlData: getUrlData,
    setFormData: setFormData,
    setUrlData: setUrlData,
    getDataForUrl : getDataForUrl,
    getLang: getLang,
    scrollToElement: scrollToElement,
    smallWin: smallWin,
    formatMoney: formatMoney,
    formatDate: formatDate,
    formatTravelPeriod: formatTravelPeriod,
    formatDateYmd: formatDateYmd,
    setCookie: setCookie,
    getCookie: getCookie,
    isObject: isObject,
    isMobile: isMobile,
    getSwipeDirection: getSwipeDirection,
    parseIfBool: parseIfBool,
    markFavorites: markFavorites,
    favoritesLabel: favoritesLabel,
    cleanParams: cleanParams,
};